import { Injectable } from '@angular/core';
import { LocalStorageKey } from '../enums/local-storage.enum';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private _collapsable = new BehaviorSubject<boolean | null>(
    localStorage.getItem(LocalStorageKey.Collapsable) === 'true'
  );

  isCollapsable = this._collapsable.asObservable();

  getCollapse(): boolean {
    const collapsable = localStorage.getItem(LocalStorageKey.Collapsable);
    return collapsable?.toLowerCase() === 'true';
  }

  setCollapse(value: boolean) {
    this._collapsable.next(value);
    localStorage.setItem(LocalStorageKey.Collapsable, value.toString());
  }
}
